export const userError = {
  login_user_001: 'UCE|LU-001',
  login_user_002: 'UCE|LU-002',
  login_user_003: 'UCE|LU-003',
  update_user_001: 'UCE|UU-001',
  update_user_002: 'UCE|UU-002',
  update_user_avatar_001: 'UCE|UUA-001',
  update_user_avatar_002: 'UCE|UUA-002',
  delete_user_001: 'UCE|DU-001',
  update_language_001: 'UCE|UL-001',
  update_language_002: 'UCE|UL-002',
  selectUserSuperAdmin_001: 'UCE|SUSA-001',
  selectUserSuperAdmin_002: 'UCE|SUSA-002',
};

export const companyError = {
  getCompanyData_001: 'UCE|GCD-001',
  getCompanyData_002: 'UCE|GCD-002',
  update_company_001: 'UCE|UC-001',
  update_company_002: 'UCE|UC-002',
  update_company_003: 'UCE|UC-003',
  add_social_media_001: 'UCE|ASM-001',
  update_company_logo_001: 'UCE|UCL-001',
  update_company_logo_002: 'UCE|UCL-002',
  updateSocialMedia_001: 'UCE|USM-001',
  updateSocialMedia_002: 'UCE|USM-002',
  removeSocialMedia_001: 'UCE|RSM-001',
  removeSocialMedia_002: 'UCE|RSM-002',
  selectCompanySuperAdmin_001: 'UCE|SCSA-001',
  selectCompanySuperAdmin_002: 'UCE|SCSA-002',
};

export const mainContactError = {
  get_contacts_001: 'MCE|GC-001',
  get_contacts_002: 'MCE|GC-002',
  select_contact_001: 'MCE|SC-001',
  create_contact_001: 'MCE|CC-001',
  create_contact_002: 'MCE|CC-002',
  update_contact_001: 'MCE|UC-001',
  update_contact_002: 'MCE|UC-002',
  update_contact_003: 'MCE|UC-003',
  update_contact_004: 'MCE|UC-004',
  remove_contact_001: 'MCE|RC-001',
  remove_contact_002: 'MCE|RC-002',
};

export const myBrandsError = {
  get_my_brands_001: 'MBE|GMB-001',
  get_my_brands_002: 'MBE|GMB-002',
  remove_my_from_my_brands_001: 'MBE|RMB-001',
  remove_my_from_my_brands_002: 'MBE|RMB-002',
  remove_my_from_my_brands_multiple_001: 'MBE|RMBM-001',
  remove_my_from_my_brands_multiple_002: 'MBE|RMBM-002',
  add_to_my_brands_001: 'MBE|ATMB-001',
  add_to_my_brands_002: 'MBE|ATMB-002',
  add_to_my_brands_003: 'MBE|ATMB-003',
  add_to_my_brands_004: 'MBE|ATMB-004',
  add_to_my_brands_multiple_001: 'MBE|ATMBM-001',
  resend_association_email_001: 'MBE|RAE-001',
  resend_association_email_002: 'MBE|RAE-002',
};

export const brandsError = {
  getPaginationBrands_001: 'MBE|GPB-001',
  getPaginationBrands_002: 'MBE|GPB-002',
  getAllBrands_001: 'MBE|GAB-001',
  getAllBrands_002: 'MBE|GAB-002',
  addMoreBrands_001: 'MBE|AMB-001',
  addMoreBrands_002: 'MBE|AMB-002',
};

export const brandError = {
  get_brand_001: 'BE|GB-001',
  get_brand_002: 'BE|GB-002',
  get_brand_003: 'BE|GB-003',
  share_data_with_brand_001: 'BE|SDWB-001',
  share_data_with_brand_002: 'BE|SDWB-002',
};

export const tenantFeedError = {
  getTenantFeed_001: 'BFE|GTF-001',
  getVideosByBrand_001: 'BFE|GVBB-001',
  getAndOrderImagesCatalog_001: 'BFE|GAOIC-001',
};

export const pointsOfSaleError = {
  get_points_of_sale_001: 'PSE|GPS-001',
  get_points_of_sale_002: 'PSE|GPS-002',
  get_points_of_sale_003: 'PSE|GPS-003',
  get_points_of_sale_004: 'PSE|GPS-004',
  create_point_of_sale_001: 'PSE|CPS-001',
  create_point_of_sale_002: 'PSE|CPS-002',
  create_point_of_sale_003: 'PSE|CPS-003',
  update_point_of_sale_001: 'PSE|UPS-001',
  update_point_of_sale_002: 'PSE|UPS-002',
  update_point_of_sale_003: 'PSE|UPS-003',
  remove_point_of_sale_001: 'PSE|RPS-001',
  remove_point_of_sale_002: 'PSE|RPS-002',
  get_exchanges_001: 'PSE|GE-001',
  get_exchanges_002: 'PSE|GE-002',
};

export const brandUsersError = {
  get_brand_users_001: 'BUE|GBU-001',
  create_brand_user_001: 'BUE|CBU-001',
  create_brand_user_002: 'BUE|CBU-002',
  update_brand_user_001: 'BUE|UBU-001',
  update_brand_user_002: 'BUE|UBU-002',
  update_brand_user_003: 'BUE|UBU-003',
  update_brand_user_004: 'BUE|UBU-004',
  update_brand_user_005: 'BUE|UBU-005',
  update_brand_user_006: 'BUE|UBU-006',
};

export const multimediaError = {
  get_multimedia_001: 'MME|GM-001',
  get_more_multimedia_001: 'MME|GMM-001',
  search_multimedia_001: 'MME|SM-001',
  select_image_multimedia_001: 'MME|RIM-001',
  get_by_brand_001: 'MME|GB-001',
};

export const catalogError = {
  get_catalog_001: 'CE|GC-001',
  getProduct_001: 'CE|GP-001',
  getProduct_002: 'CE|GP-002',
  add_more_products_to_catalog_001: 'CE|AMPTC-001',
  search_catalog_001: 'CE|SC-001',
  filter_catalog_001: 'CE|FC-001',
  sort_by_001: 'CE|SB-001',
  sort_by_brand_001: 'CE|SBB-001',
  addLike_001: 'CE|AL-001',
  addLike_002: 'CE|AL-002',
  removeLike_001: 'CE|RL-001',
  removeLike_002: 'CE|RL-002',
};

export const salesError = {
  get_sales_history_001: 'CSV|GSH-001',
  reject_upload_001: 'CSV|RU-001',
  reject_upload_002: 'CSV|RU-002',
  get_mappings_001: 'CSV|GM-001',
  get_mappings_002: 'CSV|GM-002',
  get_mappings_003: 'CSV|GM-003',
  delete_mapping_001: 'CSV|DM-001',
  delete_mapping_002: 'CSV|DM-002',
  create_mapping_001: 'CSV|CM-001',
  create_mapping_002: 'CSV|CM-002',
  create_mapping_003: 'CSV|CM-003',
  create_mapping_004: 'CSV|CM-004',
  save_sales_file_001: 'CSV|SSF-001',
  save_sales_file_002: 'CSV|SSF-002',
  update_points_of_sale_map_001: 'CSV|UPSM-001',
  update_points_of_sale_map_002: 'CSV|UPSM-002',
  update_points_of_sale_map_003: 'CSV|UPSM-003',
};

export const metaError = {
  // Connections
  get_connections_001: 'ME|GC-001',

  // Map fields
  get_map_fields_001: 'ME|GMF-001',
  create_map_field_001: 'ME|CMF-001',
  create_map_field_002: 'ME|CMF-002',
  update_map_field_001: 'ME|UMF-001',
  update_map_field_002: 'ME|UMF-002',
  add_field_to_map_001: 'ME|AFM-001',
  // create_map_field_003: 'ME|CMF-003',
  // create_map_field_004: 'ME|CMF-004',
  // create_map_field_005: 'ME|CMF-005',
  delete_map_field_001: 'ME|DMF-001',
  delete_map_field_002: 'ME|DMF-002',
  delete_map_fields_001: 'ME|DMFS-001',
  delete_map_fields_002: 'ME|DMFS-002',
  // // Map fields temp0lates
  get_map_fields_templates_001: 'ME|GMFT-001',
  // get_shopify_queries_001: 'ME|GSQ-001',
  // create_map_fields_template_001: 'ME|CMFT-001',
  // create_map_fields_template_002: 'ME|CMFT-002',
  delete_map_field_template_001: 'ME|DMFT-001',
  delete_map_field_template_002: 'ME|DMFT-002',
  copy_map_fields_template_001: 'ME|CMFT-001',
  copy_map_fields_template_002: 'ME|CMFT-002',

  // SFTP
  delete_sftp_connection_001: 'ME|DSC-001',
  delete_sftp_connection_002: 'ME|DSC-002',
  create_sftp_connection_001: 'ME|CSC-001',
  create_sftp_connection_002: 'ME|CSC-002',
  update_sftp_connection_001: 'ME|USC-001',
  update_sftp_connection_002: 'ME|USC-002',
  // Shopify
  create_shopify_connection_001: 'ME|CSHC-001',
  create_shopify_connection_002: 'ME|CSHC-002',
  create_shopify_connection_003: 'ME|CSHC-003',
  create_shopify_connection_004: 'ME|CSHC-004',
  update_shopify_connection_001: 'ME|USC-001',
  update_shopify_connection_002: 'ME|USC-002',
  delete_shopify_connection_001: 'ME|DSC-001',
  delete_shopify_connection_002: 'ME|DSC-002',
  // Configuration
  get_shopify_configuration_001: 'ME|GSC-001',
  create_update_shopify_configuration_001: 'ME|CUSC-001',
  create_update_shopify_configuration_002: 'ME|CUSC-002',
  // Maps
  get_maps_001: 'ME|GM-001',
  create_map_001: 'ME|CM-001',
  create_map_002: 'ME|CM-002',
  create_map_003: 'ME|CM-003',
  create_map_004: 'ME|CM-004',
  delete_map_001: 'ME|DM-001',
  delete_map_002: 'ME|DM-002',
  update_map_001: 'ME|UM-001',
  update_map_002: 'ME|UM-002',
  add_map_to_connector_001: 'ME|AMTC-001',
  add_map_to_connector_002: 'ME|AMTC-002',
  delete_map_from_connector_001: 'ME|DMFC-001',
  delete_map_from_connector_002: 'ME|DMFC-002',
  add_map_fields_to_map_001: 'ME|AMFTM-001',
  add_map_fields_to_map_002: 'ME|AMFTM-002',
  // Queries
  get_shopify_queries_001: 'ME|GSQ-001',
  create_shopify_query_001: 'ME|CSQ-001',
  create_shopify_query_002: 'ME|CSQ-002',
  delete_shopify_query_001: 'ME|DSQ-001',
  delete_shopify_query_002: 'ME|DSQ-002',
  update_shopify_query_001: 'ME|USQ-001',
  update_shopify_query_002: 'ME|USQ-002',
  get_shopify_templates_001: 'ME|GST-001',
  create_update_shopify_template_001: 'ME|CUST-001',
  create_update_shopify_template_002: 'ME|CUST-002',
  delete_shopify_template_001: 'ME|DST-001',
  delete_shopify_template_002: 'ME|DST-002',
  remove_map_field_from_map_001: 'ME|RMFFM-001',
  remove_map_field_from_map_002: 'ME|RMFFM-002',
  remove_map_fields_from_map_001: 'ME|RMFFM-001',
  remove_map_fields_from_map_002: 'ME|RMFFM-002',
};

export const superAdminError = {
  getClients_001: 'SAE|GC-001',
  get_map_fields_001: 'ME|GMF-001',
  create_map_field_001: 'ME|CMF-001',
  create_map_field_002: 'ME|CMF-002',
  create_map_field_003: 'ME|CMF-003',
  create_map_field_004: 'ME|CMF-004',
  create_map_field_005: 'ME|CMF-005',
  update_map_field_001: 'ME|UMF-001',
  update_map_field_002: 'ME|UMF-002',
  delete_map_field_001: 'ME|DMF-001',
  delete_map_field_002: 'ME|DMF-002',
  addUserClient_001: 'ME|AUC-001',
  removeUserClient_001: 'ME|RUC-001',
  // Map fields temp0lates
  get_map_fields_templates_001: 'ME|GMFT-001',
  get_shopify_queries_001: 'ME|GSQ-001',
  create_map_fields_template_001: 'ME|CMFT-001',
  create_map_fields_template_002: 'ME|CMFT-002',
  delete_map_field_template_001: 'ME|DMFT-001',
  delete_map_field_template_002: 'ME|DMFT-002',
  // Queries
  create_shopify_query_001: 'ME|CSQ-001',
  create_shopify_query_002: 'ME|CSQ-002',
  delete_shopify_query_001: 'ME|DSQ-001',
  delete_shopify_query_002: 'ME|DSQ-002',
  update_shopify_query_001: 'ME|USQ-001',
  update_shopify_query_002: 'ME|USQ-002',
  get_shopify_templates_001: 'ME|GST-001',
  create_update_shopify_template_001: 'ME|CUST-001',
  create_update_shopify_template_002: 'ME|CUST-002',
  delete_shopify_template_001: 'ME|DST-001',
  delete_shopify_template_002: 'ME|DST-002',
};

export const salesMatchingError = {
  getSalesMatchingAction_001: 'CURE|GSI-001',
  searchOnCatalogItemsAction_001: 'CURE|SCA-001',
  handlePaginationAction_001: 'CURE|HPA-001',
  setOwnClientProductAction_001: 'CURE|SOCPA-001',
  setOwnClientProductAction_002: 'CURE|SOCPA-002',
  addToSalesMatchingToUpdateBrandAction_001: 'CURE|ATSMUB-001',
  addToSalesMatchingToUpdateBrandAction_002: 'CURE|ATSMUB-002',
  addToSalesMatchingToUpdateReferenceAction_001: 'CURE|ATSMUR-001',
  addToSalesMatchingToUpdateReferenceAction_002: 'CURE|ATSMUR-002',
  addToSalesMatchingToUpdateReferenceAction_003: 'CURE|ATSMUR-003',
  addToSalesMatchingToUpdateColorAction_001: 'CURE|ATSMUC-001',
  addToSalesMatchingToUpdateColorAction_002: 'CURE|ATSMUC-002',
  addToSalesMatchingToUpdateSizeAction_001: 'CURE|ATSMUS-001',
  addToSalesMatchingToUpdateSkuAction_001: 'CURE|ATSMUSK-001',
  matchSaleAction_001: 'CURE|MSA-001',
  matchSaleAction_002: 'CURE|MSA-002',
  matchSaleAction_003: 'CURE|MSA-003',
  matchSaleAction_004: 'CURE|MSA-004',
  matchSaleActionSimilarItems_001: 'CURE|MSASI-001',
  matchSaleActionSimilarItems_002: 'CURE|MSASI-002',
  matchSaleActionSimilarItems_003: 'CURE|MSASI-003',
  getReferencesOptionsAction_001: 'CURE|GRO-001',
  getReferencesOptionsAction_002: 'CURE|GRO-002',
  getReferencesOptionsAction_003: 'CURE|GRO-003',
  unmatchSalesAction_001: 'CURE|USA-001',
  unmatchSalesAction_002: 'CURE|USA-002',
  unmatchSalesAction_003: 'CURE|USA-003',
};

export const changePasswordError = {
  changePassword_1: 'CPE|CP-001',
  changePassword_2: 'CPE|CP-002',
  changePassword_3: 'CPE|CP-003',
};

export const dataIntegrationError = {
  // History
  getUploadsHistory_001: 'DIE|GUH-001',
  handlePaginationAction_001: 'DIE|HPA-001',
  searchOnUploadsHistory_001: 'DIE|SOUH-001',
  // Audiences
  getAudiences_001: 'DIE|GA-001',
  createAudience_001: 'DIE|CA-001',
  createAudience_002: 'DIE|CA-002',
  updateAudience_001: 'DIE|UA-001',
  updateAudience_002: 'DIE|UA-002',
  // Mapping Fields
  getMappingFields_001: 'DIE|GMF-001',
  createMappingField_001: 'DIE|CMF-001',
  createMappingField_002: 'DIE|CMF-002',
  updateMappingField_001: 'DIE|UMF-001',
  updateMappingField_002: 'DIE|UMF-002',
  deleteMappingField_001: 'DIE|DMF-001',
  deleteMappingField_002: 'DIE|DMF-002',
  // Mappings
  getMappings_001: 'DIE|GM-001',
  createMapping_001: 'DIE|CM-001',
  createMapping_002: 'DIE|CM-002',
  deleteMap_001: 'DIE|DM-001',
  deleteMap_002: 'DIE|DM-002',
  // Points of Sale Dictionary
  getPointsOfSaleDictionary_001: 'DIE|GPSD-001',
  createPointsOfSaleDictionary_001: 'DIE|CPSD-001',
  createPointsOfSaleDictionary_002: 'DIE|CPSD-002',
  // File Patterns
  getFilePatterns_001: 'DIE|GFP-001',
  createFilePattern_001: 'DIE|CFP-001',
  createFilePattern_002: 'DIE|CFP-002',
  // Upload files
  uploadFiles_001: 'DIE|UF-001',
  uploadFiles_002: 'DIE|UF-002',
  reprocessImport_001: 'DIE|RI-001',
  reprocessImport_002: 'DIE|RI-002',
  updateInboxFileEncoding_001: 'DIE|UIFE-001',
  updateInboxFileEncoding_002: 'DIE|UIFE-002',
  archiveFileHistory_001: 'DIE|AFH-001',
  archiveFileHistory_002: 'DIE|AFH-002',
};

export const transactionsError = {
  // Delivery Notes
  getDeliveryNotesItems_001: 'TE|GDNI-001',
  getDeliveryNotesItems_002: 'TE|GDNI-002',
  getDeliveryNotesColumns_001: 'TE|GDNC-001',
  getDeliveryNotesColumns_002: 'TE|GDNC-002',
  searchOnDeliveryNotesItemsAction_001: 'TE|SDNA-001',
  handleDeliveryNotesPaginationAction_001: 'TE|HPA-001',
  // Bills
  getBillsItems_001: 'TE|GBI-001',
  getBillsItems_002: 'TE|GBI-002',
  getBillsColumns_001: 'TE|GBC-001',
  getBillsColumns_002: 'TE|GBC-002',
  searchOnBillsItemsAction_001: 'TE|SBA-001',
  handleBillsPaginationAction_001: 'TE|HBPA-001',
  // Orders
  getOrdersItems_001: 'TE|GOI-001',
  getOrdersItems_002: 'TE|GOI-002',
  getOrdersColumns_001: 'TE|GOC-001',
  getOrdersColumns_002: 'TE|GOC-002',
  searchOnOrdersItemsAction_001: 'TE|SOA-001',
  handleOrdersPaginationAction_001: 'TE|HOPA-001',
};
